import React from "react"
import { useTranslation } from "react-i18next"

import Table from "components/ui/Table"
import { DATE_TYPE, MONEY_TYPE, STRING_TYPE } from "config"
import { PaymentScheduleInvoiceType } from "types"

type Props = {
  invoices: PaymentScheduleInvoiceType[]
}

const InvoicesComponent = ({ invoices }: Props) => {
  const { t } = useTranslation()

  const HEADER = [
    {
      label: t("features.payment_schedule.table.due_date"),
      field: "due_date",
      format: DATE_TYPE,
      minWidth: 100,
    },
    {
      label: t("features.payment_schedule.table.balance"),
      field: "balance",
      format: MONEY_TYPE,
      minWidth: 100,
    },
    {
      label: t("features.payment_schedule.table.principal"),
      field: "principal",
      format: MONEY_TYPE,
      minWidth: 100,
    },
    {
      label: t("features.payment_schedule.table.total_interest_sum"),
      field: "total_interest_sum",
      format: MONEY_TYPE,
      minWidth: 100,
    },
    {
      label: t("features.payment_schedule.table.payment"),
      field: "unpaid_sum",
      format: MONEY_TYPE,
      minWidth: 100,
    },
  ]

  const FOOTER = [
    {
      field: "total",
      value: t("features.payment_schedule.table.total"),
      format: STRING_TYPE,
      minWidth: 100,
    },
    {
      field: "balance",
      value: Math.max(
        ...invoices.map((item: PaymentScheduleInvoiceType) => item.balance),
      ),
      format: MONEY_TYPE,
      minWidth: 100,
    },
    {
      field: "principal",
      value: invoices.reduce(
        (index: number, item: PaymentScheduleInvoiceType) =>
          index + item.principal,
        0,
      ),
      format: MONEY_TYPE,
      minWidth: 100,
    },
    {
      field: "interest",
      value: invoices.reduce(
        (index: number, item: PaymentScheduleInvoiceType) =>
          index + item.total_interest_sum,
        0,
      ),
      format: MONEY_TYPE,
      minWidth: 100,
    },
    {
      field: "unpaid",
      value: invoices.reduce(
        (index: number, item: PaymentScheduleInvoiceType) =>
          index + item.unpaid_sum,
        0,
      ),
      format: MONEY_TYPE,
      minWidth: 100,
    },
  ]

  return (
    <Table
      fade
      sx={{ maxHeight: 460, marginBottom: "26px" }}
      header={HEADER}
      footer={FOOTER}
      items={invoices}
    />
  )
}

InvoicesComponent.defaultProps = {
  invoices: [],
}

export default InvoicesComponent
